import { useTranslation } from 'next-i18next';
import React from 'react';

import { useGetHomeApprovals } from '@/modules/home/apiHooks';
import ApprovalsTable from '@/modules/home/components/PageContent/Approvals/Table';
import HomeCardWrapper from '@/modules/home/components/shared/CardWrapper';
import { Typography } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Clipboard from '~/images/shared/clipboard-tick.svg';

const HomeApprovalsSection = () => {
  const { t } = useTranslation();

  const [selectedAsset] = useStore((store) => store?.asset);

  const { data, fetchNextPage, hasNextPage } = useGetHomeApprovals({
    entityId: selectedAsset?.id,
    pageSize: 10,
    pageNumber: 1,
  });

  return (
    <HomeCardWrapper
      icon={<Clipboard width='24' height='24' />}
      title={
        <div className='flex items-center gap-8'>
          <Typography weight='bold'>{t('approvals')}</Typography>
          <Typography
            weight='medium'
            variant='caption'
            className=' flex items-center justify-center rounded-xl bg-neutralVariant-96 px-8 py-4 text-tertiary-20'
          >
            {`${data?.pages?.[0]?.totalCount ?? 0} ${t('pending')}`}
          </Typography>
        </div>
      }
    >
      <ApprovalsTable
        infiniteScrollProps={{
          loadMore: () => fetchNextPage(),
          hasMore: hasNextPage,
        }}
        data={data?.pages.flatMap((page) => page.approvals)}
      />
    </HomeCardWrapper>
  );
};

export default HomeApprovalsSection;
